import { getRumInstance } from 'src/rum';
import { logger } from 'src/logger';

/**
 * Emits a named event to all observability backends.
 * Fans out to AWS RUM (as a custom event) and Katal logger.
 *
 * Baseline context (timestamp, route) is attached automatically.
 * Feature code calls this for workflow lifecycle events:
 *   emit('audit.perform.started', { auditId })
 *   emit('task.perform.completed', { taskId, durationMs })
 *
 * RUM: routed through the app's Midway-based RUM instance (src/rum).
 * SharedReactLib's recordEvent() is not used here because its module-level
 * instance is initialized via Cognito initRum(), which this app does not
 * use — it authenticates RUM with Midway credentials instead.
 */
export function emit(name: string, payload?: Record<string, unknown>): void {
  const event = {
    name,
    timestamp: Date.now(),
    route: window.location.pathname,
    ...payload,
  };

  // Log structured event
  void logger.info(`[event] ${name}`, event);

  // Record in RUM as custom event (no-op if RUM not initialized)
  void getRumInstance().then((rum) => {
    rum?.recordEvent(name, event);
  });
}
